import React from 'react';

import Card from '../../../../../components/Card/index';
import FinalSummaryTable from '../Steps/Components/FinalSummaryTable';

const Completed = ({ user, registration }) => {
  if (registration.trainingId) {
    return (
      <Card>
        <Card.Header>Completed!</Card.Header>
        <Card.Body>
          <h2>Congratulations! Your training is complete!</h2>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Header>Certified!</Card.Header>
      <Card.Body>
        <h2>Congratulations! You're certified!</h2>
        <p>Your information is below for reference</p>
        <FinalSummaryTable user={user} registration={registration} />
      </Card.Body>
    </Card>
  );
};

export default Completed;
